<template>
    <div>
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Status</h2>
        <div v-html="getStatus()" class="bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm">
        </div>
    </div>
</template>

<script>

import {InspectionTestPlan} from "../../models";
import moment from "moment";

export default {
    props: {
        inspectionTestPlan: InspectionTestPlan,
    },
    data() {
        return {
            lastSaving: false,
            lastSaved: false,
            interval: 0,
        }
    },
    methods: {
        getStatus() {
            if (this.inspectionTestPlan.saving) {
                if (moment().diff(this.lastSaving,'seconds')>3) {
                    return 'Saving...<br/><br/>Connection interrupt detected......   Continuing to attempt to save..'
                }
                return 'Saving...'
            } else {
                return this.lastSaved ? 'Saved ' + this.lastSaved.fromNow() : 'No changes yet made';
            }
        }
    },
    mounted() {
        eventBus.$on('inspection-test-plan-saving', (inspectionTestPlan) => {
            if (inspectionTestPlan === this.inspectionTestPlan) {
                this.lastSaving = moment()
                this.$forceUpdate();
            }
        });
        eventBus.$on('inspection-test-plan-saved', (inspectionTestPlan) => {
            if (inspectionTestPlan === this.inspectionTestPlan) {
                this.lastSaved = moment()
            }
        });
        this.interval = setInterval(() => {
            this.$forceUpdate();
        }, 1000);
    }
}
</script>
